import {NEARBY_ROUTE, NEARBY_STOP, NEARBY_STOP_BY_ROUTE} from "../config/paths/apiPaths";
import locationPromise from "../config/location/locationPromise";

export default {
  namespaced: true,

  state: {
    locationSet: false,
    loading: false,
    userLocation: {},
    routes: [],
    stops: [],
    byRoute: [],
    byStops: [],
  },

  mutations: {
    setRoutes(state, routes) {
      state.routes = routes;
      state.loading = false;
    },
    setStops(state, stops) {
      console.log('setting stops', stops);

      state.stops = stops;
      state.loading = false;
    },
    setStopByRoute(state, data) {
      state.byRoute = data;
      state.loading = false;
    },

    setUserLocation(state, location) {
      state.userLocation = location;
      state.locationSet = true;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },

  actions: {
    async getNearbyRouteList({commit, state}, data) {
      commit('setLoading', true);

      if (!state.locationSet) {
        const location = await locationPromise();
        commit('setUserLocation', location);
      }

      const requestData = {
        ...data,
        lat: state.userLocation.lat,
        lng: state.userLocation.lng,
      };

      fetch(`${NEARBY_ROUTE}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(requestData),
      })
        .then(response => response.json())
        .then(json => {
          commit('setRoutes', json.data.records);
        });

      fetch(`${NEARBY_STOP}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(requestData),
      })
        .then(response => response.json())
        .then(json => {
          commit('setStops', json.data);
        });

    },
    async getNearbyStopByRoute({commit, state}, data) {
      commit('setLoading', true);

      if (!state.locationSet) {
        const location = await locationPromise();
        commit('setUserLocation', location);
      }

      const requestData = {
        ...data,
        lat: state.userLocation.lat,
        lng: state.userLocation.lng,
      };

      console.log(requestData);

      fetch(`${NEARBY_STOP_BY_ROUTE}`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(requestData),
      })
        .then(response => response.json())
        .then(json => {
          console.log('setting records: ', json.data);

          commit('setStopByRoute', json.data);
        })
    },


  },

  getters: {},


}
